module.exports = __webpack_public_path__ + "img/panda.8498c62c.png";